import { render } from "./DocumentSettings.vue?vue&type=template&id=447e6dd9"
import script from "./DocumentSettings.vue?vue&type=script&lang=js"
export * from "./DocumentSettings.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__